"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[951],{

/***/ 55237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* unused harmony exports ALIGN_OPTIONS, SIZE_OPTIONS, FONT_OPTIONS, TextMemo */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67573);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51123);
/* harmony import */ var _helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21236);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23302);







var ALIGN_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .ALIGNMENTS */ .Eu, "left", "center", "right", "auto");
var SIZE_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .SIZES */ .zf, "sm", "md", "lg", "xl", "2xl");
var FONT_OPTIONS = (0,_helpers_utils_object__WEBPACK_IMPORTED_MODULE_5__/* .pick */ .e)(_types__WEBPACK_IMPORTED_MODULE_4__/* .FONTS */ .g5, "heading", "sans", "mono");
var alignClasses = {
    auto: "",
    left: "text-left",
    center: "text-center mx-auto",
    right: "text-right ml-auto"
};
var sizeClasses = {
    sm: "prose-sm md:prose-md",
    md: "prose-md md:prose-base",
    lg: "prose-lg md:prose-xl",
    xl: "prose-lg md:prose-2xl",
    "2xl": "prose-lg md:prose-2xl xl:prose-3xl"
};
var fontClasses = {
    sans: "font-sans",
    mono: "font-mono",
    heading: "font-sans"
};
var Text = function(param) {
    var children = param.children, _as = param.as, as = _as === void 0 ? "div" : _as, background = param.background, color = param.color, _align = param.align, align = _align === void 0 ? "left" : _align, _size = param.size, size = _size === void 0 ? "lg" : _size, className = param.className, _font = param.font, font = _font === void 0 ? "sans" : _font;
    var Element = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Element, {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("break-words prose font-regular leading-relaxed", "prose-strong:font-bold prose-strong:text-current", "prose-a:underline prose-a:underline-offset-4", alignClasses[align], sizeClasses[size], fontClasses[font], color ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .textClasses */ .Gb[color] : background ? _colors__WEBPACK_IMPORTED_MODULE_3__/* .proseClasses */ .fh[background] : "text-current", (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, "prose-a:text-action-base", !background || background === "white" || background === "neutral-95")),
            children: children
        })
    });
};
var TextMemo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.memo(Text)));


/***/ }),

/***/ 50834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Article": function() { return /* binding */ Article; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14251);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52875);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_module_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55237);
/* harmony import */ var _components_module_Wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83118);







var Article = function(param) {
    var theme = param.theme, content = param.content;
    var ref, ref1, ref2, ref3;
    if (!content) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Wrapper__WEBPACK_IMPORTED_MODULE_4__/* .Wrapper */ .i, {
        theme: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, theme === null || theme === void 0 ? void 0 : theme.module), {
            space: {
                top: (theme === null || theme === void 0 ? void 0 : (ref = theme.module) === null || ref === void 0 ? void 0 : (ref1 = ref.space) === null || ref1 === void 0 ? void 0 : ref1.top) || "xs",
                bottom: theme === null || theme === void 0 ? void 0 : (ref2 = theme.module) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.space) === null || ref3 === void 0 ? void 0 : ref3.bottom
            }
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "grid grid-cols-12",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "col-span-12 lg:col-span-8 lg:col-start-3 w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_module_Text__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                    background: "white",
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(// reset prose width
                    "[&_.prose]:max-w-none", // reset default media width
                    "[&_.prose-media]:max-w-screen [&_.prose-media]:w-auto", // pull images out of 8/12 column
                    // first one 100% container width
                    "lg:[&_.prose-media:first-of-type_.image]:w-[calc(100%/8*12)]", "lg:[&_.prose-media:first-of-type_.image]:-translate-x-[calc(100%/12*2)]", // others slightly wider than 8 columns
                    "lg:[&_.prose-media:not(:first-of-type)_.image]:w-[calc(100%/8*9)]", "lg:[&_.prose-media:not(:first-of-type)_.image]:-translate-x-[calc(100%/12*.66)]", // rounded corners on image
                    "[&_.prose-media_.image]:overflow-hidden", "[&_.prose-media_.image]:rounded-3xl [&_.prose-media_.image]:md:rounded-4xl [&_.prose-media_.image]:lg:rounded-5xl"),
                    children: content
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(Article));


/***/ })

}]);